import { useSyncExternalStore } from "react";

type Listener = () => void;

function createNowStore(intervalMs: number) {
  let now = new Date();
  const listeners = new Set<Listener>();

  const interval = setInterval(() => {
    now = new Date();
    listeners.forEach((l) => l());
  }, intervalMs);

  return {
    subscribe(listener: Listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) clearInterval(interval);
      };
    },
    getSnapshot() {
      return now;
    },
  };
}

const stores = new Map<number, ReturnType<typeof createNowStore>>();

function getNowStore(intervalMs: number) {
  if (!stores.has(intervalMs)) {
    stores.set(intervalMs, createNowStore(intervalMs));
  }
  return stores.get(intervalMs)!;
}

/**
 * Returns the current time, updated on the given interval (default 5s).
 * All callers with the same interval share one setInterval.
 */
export function useNow(intervalMs = 5_000): Date {
  const store = getNowStore(intervalMs);
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}
